import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('eden-admin-auth') === 'true';
  });
  const [adminToken, setAdminToken] = useState(() => {
    return localStorage.getItem('eden-admin-token');
  });

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API}/admin/login`, {
        email: username,  // API uses email field for username
        password: password
      });
      
      const { token } = response.data;
      setAdminToken(token);
      setIsAuthenticated(true);
      localStorage.setItem('eden-admin-auth', 'true');
      localStorage.setItem('eden-admin-token', token);
      return true;
    } catch (error) {
      console.error('Admin login failed:', error);
      return false;
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setAdminToken(null);
    localStorage.removeItem('eden-admin-auth');
    localStorage.removeItem('eden-admin-token');
  };

  const changePassword = async (currentPassword, newPassword) => {
    try {
      await axios.put(
        `${API}/admin/password`,
        null,
        {
          params: {
            current_password: currentPassword,
            new_password: newPassword
          },
          headers: {
            Authorization: `Bearer ${adminToken}`
          }
        }
      );
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Failed to change password' 
      };
    }
  };

  return (
    <AdminContext.Provider value={{ isAuthenticated, adminToken, login, logout, changePassword }}>
      {children}
    </AdminContext.Provider>
  );
};
